import React, { useEffect } from "react";
import Navbar from "../components/Navbar/navbar";
import Footer from "../components/Footer/footer";
import AboutUs from "../components/About/about";

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Navbar />
      <AboutUs />
      <Footer />
    </div>
  );
};

export default About;
